import React from 'react';

function Section() {
  return (
    <>
      <section className="looking-perks" data-aos="fade-up" data-aos-delay={100}>
        <div className="inner-wrap">
          <div
            className="container image"
            style={{ backgroundImage: 'url("WhyWorkATnlf.jpg")' }}
          >
            <div className="container big-container">
              <div className="row">
                <div
                  className="col-lg-12"
                  data-aos="fade-down"
                  data-aos-delay={100}
                >
                  <div className="content-wrap text-center">
                    <h2>Why Work at NLF?</h2>
                    {/* <p>Where creativity meets craftsmanship.</p> */}
                  </div>
                </div>

                <div className="col-sm-12 col-md-4">
                  <div className="looking-perks-box">
                    <img src="career-img/img1.jpg" alt="Innovative Culture" />
                    <p>
                      Work on cutting-edge turnkey interiors, green building solutions, and bespoke furniture.
                    </p>
                  </div>
                </div>

                <div className="col-sm-12 col-md-4">
                  <div className="looking-perks-box">
                    <img src="career-img/img2.png" alt="Collaborative Environment" />
                    <p>
                      Join a multidisciplinary team where ideas flow freely—from design boards to built spaces.
                    </p>
                  </div>
                </div>

                <div className="col-sm-12 col-md-4">
                  <div className="looking-perks-box">
                    <img src="career-img/img3.png" alt="Legacy & Craftsmanship" />
                    <p>
                      Be part of a legacy brand known for precision, artistry, and timeless aesthetic sensibility.
                    </p>
                  </div>
                </div>

                <div className="col-sm-12 col-md-4">
                  <div className="looking-perks-box">
                    <img src="career-img/img4.png" alt="Growth & Recognition" />
                    <p>
                      Experience a workplace that nurtures growth—with mentorship, upskilling, and real recognition.
                    </p>
                  </div>
                </div>

                <div className="col-sm-12 col-md-4">
                  <div className="looking-perks-box">
                    <img src="career-img/img5.png" alt="Well-being & Balance" />
                    <p>
                      Work-life balance, health benefits, and a serene, design-forward office culture.
                    </p>
                  </div>
                </div>

                <div className="col-sm-12 col-md-4">
                  <div className="looking-perks-box">
                    <img src="career-img/img6.jpg" alt="Recognition Culture" />
                    <p>
                      Performance-linked rewards and a culture that celebrates ideas, not just outcomes.
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Section;
